"use client";

import { useMediaQuery } from "@mui/material";
import { GridBreakpoint } from "@/constants/style";

export function useDetectDevice() {
  const isMobile = useMediaQuery(`(max-width:${GridBreakpoint.md}px)`);
  const isDesktop = useMediaQuery(`(min-width:${GridBreakpoint.lg}px)`);
  const isTablet = !isMobile && !isDesktop;

  return {
    isMobile,
    isTablet,
    isDesktop,
  };
}
